import Cookies from "js-cookie";

import { PortalUserRead } from "../store/coreApi";
import { impersonateCookieName } from "./constants";

export const isAdmin = (account?: PortalUserRead) =>
  account?.roles.includes("Admin") ?? false;

export const isInternalUser = (account?: PortalUserRead) =>
  account?.sterInlog.internalUser ?? false;

export const isInternalUserOrAdmin = (account?: PortalUserRead) =>
  isInternalUser(account) || isAdmin(account);

export const isIntermediair = (account?: PortalUserRead) =>
  account?.roles.includes("Intermediair");

export const isMedewerker = (account?: PortalUserRead) =>
  account?.roles.includes("Medewerker");

export const isImpersonating = () =>
  ["user", "intermediair"].includes(Cookies.get(impersonateCookieName) ?? "");

export const canProposeMultipleCampaigns = (account?: PortalUserRead) =>
  isIntermediair(account) || isInternalUser(account);

export const canUseProspect = (account?: PortalUserRead) =>
  isIntermediair(account) || isInternalUser(account);

export const hasClaim = (account: PortalUserRead | undefined, claim: string) =>
  account?.claims.includes(claim) ?? false;
